import { css } from "emotion";
import { Component } from "preact";
import { onEnter } from "../../../utils/Accessability";
import TicketDisplay from "./TicketDisplay";
import { determineManualOrder } from "../../../utils/ManualOrderUtils";

const dropDown = css({
  transition: "height 0.3s ease-out",
  height: 0,
  overflowY: "hidden"
});

const defaultCarrotStyles = {
  borderBottom: "1px solid #DEDEDE",
  padding: "16px 6px 16px 0",
  margin: 0,
  backgroundSize: "16px auto",
  fontSize: 16,
  display: "flex",
  justifyContent: "space-between"
};

const carot = open => {
  const currentColour = open ? "#6621c0" : "#67717e";
  const degree = open ? "-45deg" : "135deg";

  return css({
    "&::after": {
      content: `''`,
      width: 7,
      height: 7,
      borderTop: `solid 2px ${currentColour}`,
      borderRight: `solid 2px ${currentColour}`,
      transform: `rotate(${degree})`,
      marginTop: open ? 9 : 7,
      marginRight: 2,
      transitionProperty: "transform, borderTop, borderRight",
      transitionDuration: "0.1s",
      transitionTimingFunction: "ease-out"
    }
  });
};

class TicketGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  toggle = () => {
    this.setState(
      prevState => ({
        open: !prevState.open
      }),
      this.toggleChanged
    );
  };

  toggleChanged = () => {
    const { open } = this.state;
    if (!open) {
      this.collapseSection();
      return;
    }
    this.expandSection();
  };

  collapseSection = () => {
    const elem = this.dropDown;
    const sectionHeight = elem.scrollHeight;
    const elementTransition = elem.style.transition;
    elem.style.transition = "";
    elem.style.display = "none";
    window.requestAnimationFrame(() => {
      elem.style.height = sectionHeight + "px";
      elem.style.transition = elementTransition;
      window.requestAnimationFrame(() => {
        elem.style.height = 0 + "px";
      });
    });
  };

  expandSection = () => {
    const elem = this.dropDown;
    elem.style.display = "block";
    const sectionHeight = elem.scrollHeight;
    elem.style.height = sectionHeight + "px";
  };

  render() {
    const {
      group,
      tickets,
      updateDonationAmount,
      addQuantity,
      ticketsRemainingDisplay,
      showCustomDonationField,
      donationOtherOption,
      addPrice
    } = this.props;
    const { open } = this.state;
    const buttonStyle = css({
      textDecoration: "none",
      color: open ? "#6621c0" : "#323232",
      width: "100%",
      padding: "0",
      ":hover": {
        textDecoration: "none",
        color: open ? "#6621c0" : "#323232"
      }
    });
    const isManualOrder = determineManualOrder();

    const visibleTickets = isManualOrder
      ? group.ticketsWithInfo
      : group.ticketsWithInfo.filter(
          ticket => !ticket.hidden || ticket.accessGranted
        );

    const groupStyle = css([defaultCarrotStyles, carot(open)]);

    if (!visibleTickets.length) {
      // the group is empty
      return null;
    }
    const ticketsList = visibleTickets.map((ticket, index) => {
      return (
        <div style={{ marginLeft: 12 }}>
          <TicketDisplay
            tickets={tickets}
            ticket={ticket}
            updateDonationAmount={updateDonationAmount}
            addQuantity={addQuantity}
            addPrice={addPrice}
            ticketsRemainingDisplay={ticketsRemainingDisplay}
            showCustomDonationField={showCustomDonationField}
            donationOtherOption={donationOtherOption}
            ticketGroupIndex={`${group.name
              .replace(/\s/g, "-")
              .toLowerCase()}-${index + 1}`}
          />
        </div>
      );
    });
    return (
      <div
        style={{
          marginBottom: open ? 20 : 0
        }}
      >
        <button
          className={buttonStyle}
          onClick={this.toggle}
          tabIndex={0}
          aria-expanded={open ? "true" : "false"}
        >
          <h3 className={groupStyle}>{group.name}</h3>
        </button>

        <div ref={elem => (this.dropDown = elem)} className={dropDown}>
          {ticketsList}
        </div>
      </div>
    );
  }
}

export default TicketGroup;



// WEBPACK FOOTER //
// ./routes/tickets/components/TicketGroup.js